
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Map from "../../Base/Map.vue";
import DeleteBox from "../../Base/DeleteBox.vue";
import { City, CityPoint } from "@/models/City";
import { Game } from "@/models/Game";
import { MapOptions } from "@/models/Map";
import { forIn, isEqual, cloneDeep } from "lodash";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: {
    Map,
    DeleteBox,
  },
})
class CityGeneral extends Vue {
  @Prop({ default: "EN" }) readonly languageID!: string;
  @Prop({ default: null }) readonly cityData!: City;
  @Prop({ default: false }) readonly step!: boolean;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  showSavePanel = false;
  cityDataObject = {} as City;
  errors: string[] = [];

  get getCityMarkerPoints(): MapOptions[] {
    var arr = [];
    var cityCentreMarker: MapOptions = {
      position: {
        lat: this.cityData.centre_point.latitude,
        lng: this.cityData.centre_point.longitude,
      },
      title: this.cityData.name.en + " : Centre point",
      slug: "centre_point",
      draggable: false,
      clickable: false,
      zIndex: 1000,
      radius: 10,
      icon: require("@/assets/images/map/city-center-blue.svg"),
    };

    arr.push(cityCentreMarker);
    forIn(this.cityData.locations, (val: CityPoint) => {
      if (val.slug !== "centre_point") {
        var locationMarker: MapOptions = {
          position: {
            lat: val.lat_long.latitude,
            lng: val.lat_long.longitude,
          },
          title: val.name.en,
          slug: val.slug,
          draggable: false,
          clickable: true,
          zIndex: 100,
          radius: 10,
          icon: require("@/assets/images/map/city-gray.svg"),
        };

        arr.push(locationMarker);
      }
    });
    return arr;
  }

  get getErrorArray(): string[] {
    const arr: string[] = [];
    forIn(this.cityData.issues?.err, (val: any) => {
      arr.push(val.txt.en);
    });
    return arr;
  }

  get getSavePanelLock(): boolean {
    if (this.isSavedOrDiscard) {
      this.showSavePanel = false;
      return false;
    } else {
      return this.showSavePanel;
    }
  }

  get getTimeZone(): string {
    if (
      this.cityData.tZone === undefined ||
      this.cityData.tZone.timeZoneId.length == 0
    ) {
      return "Invalid";
    } else {
      return (
        this.cityData.tZone.timeZoneId + ", " + this.cityData.tZone.timeZoneName
      );
    }
  }

  get getCityGameCount(): number {
    var results = this.$store.state.gameStore.games.filter(
      (x: Game) => x.city === this.cityData.slug
    );
    return results.length;
  }

  created(): void {
    this.$v.$touch();
    this.cityDataObject = cloneDeep(this.cityData);
  }
  mapData(place: any): void {
    this.cityData.centre_point.latitude = place.latitude;
    this.cityData.centre_point.longitude = place.longitude;
    if (this.cityData.locations["centre_point"] !== undefined) {
      this.cityData.locations["centre_point"].lat_long.latitude =
        place.latitude;
      this.cityData.locations["centre_point"].lat_long.longitude =
        place.longitude;
    }
    this.onValueChanged();
  }

  deleteItem(): void {
    this.$store
      .dispatch("cityStore/deleteCity", this.cityData)
      .then((results) => {
        if (results === "success") {
          this.$emit("closeTabs");
        }
      });
  }
  openDeleteBox(): void {
    this.$bvModal.show("team-modal-delete");
  }
  onValueChanged(): void {
    var data = {
      type: "General",
      cityData: this.cityData,
      selectable: true,
    };
    if (!isEqual(this.cityData, this.cityDataObject)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", data);
  }

  checkErrors(): boolean {
    let noErrors = true;
    if (this.cityDataObject.name.en.trim().length == 0) {
      this.errors.push("Please make sure the name has an value greater than 0");
      noErrors = false;
    }
    return noErrors;
  }
  openLocation(value: string): void {
    this.$emit("openLocation", value);
  }
  setSelected(): void {
    this.$emit("setSelected");
  }
  @Watch("isEditingLocked")
  onIsEditingLockedChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }

  @Validations()
  validations = {
    cityData: {
      name: {
        en: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(160),
        },
      },
    },
  };
}

export default CityGeneral;
